import { render } from "./DirectDebitMandateFields.vue?vue&type=template&id=38761b67"
import script from "./DirectDebitMandateFields.vue?vue&type=script&lang=js"
export * from "./DirectDebitMandateFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__